import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import {
  getStripedPattern,
  getPrimerGradient,
  getSanitizedId
} from "../utils/editorUtils";
import drawDirectedPiePiece from "./drawDirectedPiePiece";
import { getInternalLabel } from "./getInternalLabel";
export default function CircularPrimer(props) {
  const {
    color: propsColor = "orange",
    radius,
    arrowheadLength = 0.5,
    annotationHeight,
    totalAngle,
    id,
    labelNeedsFlip,
    ellipsizedName,
    annotation = {},
    isStriped
  } = props;
  let color = propsColor;
  const { forward } = annotation;
  const isPrimer = !!annotation.primerId || String(annotation.type).toLowerCase() === "primer" || String(annotation.type).toLowerCase() === "primer_bind";
  if (isPrimer) {
    color = forward ? "#006600" : "#c2ffc2";
  }
  const [path, textPath] = drawDirectedPiePiece({
    radius,
    annotationHeight,
    totalAngle,
    arrowheadLength,
    tailThickness: 1,
    //feature specific
    returnTextPath: true,
    hasLabel: ellipsizedName,
    labelNeedsFlip
  });
  const sanitizedId = getSanitizedId(id);
  return /* @__PURE__ */ jsxs(React.Fragment, { children: [
    isStriped && getStripedPattern({ color, id }),
    getPrimerGradient({ id, forward: !!forward }),
    /* @__PURE__ */ jsx(
      "path",
      {
        className: "vePrimer veCircularViewPrimer",
        id,
        strokeWidth: ".5",
        stroke: "black",
        fill: `url(#primerGradient-${sanitizedId})`,
        d: path.print()
      }
    ),
    isStriped && /* @__PURE__ */ jsx(
      "path",
      {
        className: "vePrimer veCircularViewPrimer",
        strokeWidth: ".5",
        fill: `url(#diagonalHatch-${sanitizedId})`,
        d: path.print()
      }
    ),
    getInternalLabel({ ...props, colorToUse: color, textPath })
  ] });
}
